<template>
  <div
    v-if="$store.getters['authorization/acl'].hasPermission('callplanner_menu_access')"
    class="PlatformCallPlannerView"
  >
    <PageHeader
      title="Call Planner"
      description="Poniżej znajduje się kalendarz z zaplanowanymi połączeniami.<br>"
      :is-back-button-visible="false"
      :breadcrumb-items="[
        { label: 'zarządzanie' },
        { label: 'Call Planner', path: '/callplanner' }
      ]"
    />
    <div class="PlatformCallPlannerView__calendar-container">
      <Calendar />
    </div>
  </div>
</template>

<script>
import Calendar from "@/components/Calendar/";
import PageHeader from '@/components/Common/PageHeader';

export default {
  components: {
    Calendar,
    PageHeader
  }
};
</script>
